/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface ItemsItem {
    itemId?: string;
    companyId?: string;
}

export interface DetailItem {
    type?: string;
    text?: string;
    items?: ItemsItem[];
}

export interface SearchCareerClassListPayload {
    freeword?: string;
    startDate?: string;
    endDate?: string;
    careerType?: number;
    elearning?: boolean;
    shugo?: boolean;
    tuusin?: boolean;
    skillTypeList?: Array<string>;
    lowerFlg?: boolean;
    categoryId?: string;
    onlyWanted?: boolean;
    position?: boolean;
    jobCategory?: boolean;
    office?: boolean;
    detail?: DetailItem[];
    pageNo?: number;
    pageSize?: number;
}

export interface CareerResultsItem {
    careerId: string;
    careerTitle: string;
    careerType: number;
    careerTypeId: number;
    check: boolean;
    checkFlag: number;
    classId: string;
    className: string;
    cost: string;
    deadline: string;
    endDateByDay: number;
    endDateByYear: number;
    managementCode: string;
    msgId: string;
    msgParams: Array<string>;
    organizer: string;
    period: string;
    placeId: string;
    placeName: string;
    referenceUrl: string;
    target: string;
    type: string;
    webAppFlg: string;
    startDate: string;
    endDate: string;
    finishedFlg: number;
    purpose: string;
    outLine: string;
    divisionId: string;
    divisionName: string;
    subTypeId: string;
    subTypeName: string;
    skillTypeId: string;
    skillTypeName: string;
    multiApplyFlag: string;
    credit: number;
    comment: string;
    careerImageUrl: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
    applyStartDateTime: string;
    applyEndDateTime: string;
}

export interface SearchCareerClassListResponse {
    careerResults: CareerResultsItem[];
    applyFlg: number;
    pagerTotalDataCount: number;
}

class SearchCareerClassListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "searchCareerClassList");
    }

    public async searchCareerClassList(
        payload: SearchCareerClassListPayload,
        resolved: (json: SearchCareerClassListResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as SearchCareerClassListResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default SearchCareerClassListService;
